import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	state__list: 'mw/admin/state/list',
	state__set: 'mw/admin/state/set',
};

export const stateApi = createApi({
	reducerPath: 'mw/admin/stateApi',

	endpoints: (builder) => ({
		stateList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/state/list?${qs.stringify(body)}`,
				jsonType: true,
			}),
			providesTags: [tags.state__list],
		}),
		stateSet: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: `/mw/admin/state/set?${qs.stringify(body)}`,
			}),
			providesTags: [tags.state__set],
		}),
	}),
});

export const {
	stateList,
	stateSet,
} = stateApi.endpoints;

export default stateApi;